import { render, staticRenderFns } from "./admain.vue?vue&type=template&id=abe1a3a2&scoped=true&"
import script from "./admain.vue?vue&type=script&lang=js&"
export * from "./admain.vue?vue&type=script&lang=js&"
import style0 from "./admain.vue?vue&type=style&index=0&id=abe1a3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe1a3a2",
  null
  
)

export default component.exports